import React, { useEffect, useState } from "react";
// Mui
import { Grid, TextField, Typography } from "@material-ui/core";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
// Styles
import { useStyles } from "../styles";
// IndexedDb
import IndexedDb from "../IndexedDb";
import api from "../../../store/api";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { consts } from "../../../common/consts";

type TCaregivers = { name: string ; title: string ; id?: string | null};

// Default row count is 3
const initialData = [
  { name: "", title: "", id: null  },
  { name: "", title: "", id: null },
  { name: "", title: "", id: null },
];
const filter = createFilterOptions<TCaregivers>();
const Caregivers = ({setCareGiversListChanged}:any) => {
  const classes = useStyles();
  const { authStore } = useSelector((state: RootState) => state);
  const SMADriver= authStore?.data
  ? authStore?.data?.role?.indexOf(consts.Permissions.SMADriver) >= 0 && authStore?.vehicleNumber
    ? true
    : false
  : false;
  const CustomerDriver= authStore?.data
  ? authStore?.data?.role?.indexOf(consts.Permissions.CustomerDriver) >= 0 && authStore?.vehicleNumber
    ? true
    : false
  : false;

  const [state, setState] = useState<TCaregivers[]>(initialData);
  const [inputValue, setInputValue] = useState("");
  const [usersList, setUsersList] = useState<TCaregivers[]>([]);
  const [Indexdb, setIndexdb] = useState("");
  const handleOnChange = async (data: TCaregivers, index: number) => {
    setState((s) => {
      return s.map((item, i) => (i === index ? data : item));
    });

    let db = localStorage.getItem("PatientDB");
    if (db !== null && db !== "") {
      const indexedDb = new IndexedDb(db);
      await indexedDb.createObjectStore(indexedDb.patientcarerecord);

      let formData = state.map((item, i) => (i === index ? data : item));

      if (formData) {
        await indexedDb.deleteValue("Caregivers", "caregivers");
        await indexedDb.putValue(
          "Caregivers",
          { column: formData, Patid: 0 },
          "caregivers"
        );
      }
    }
  };

  const getCareGiversList = async () =>{
    try {
      const res = await api.getCareGiversList("").then((result: any) => {
        if (!result.errorRaised) {
          result = result.model;
          setUsersList(result);
        }
    }).catch((error) => {
    })
    } catch (err) {
    }
    
  }

  const setDb = async () =>{
    try {
      let db: any = null;
        let patvalue: any = null;
        db = localStorage.getItem("PatientDB");
        setIndexdb(db);
        if (SMADriver||CustomerDriver)
        patvalue=localStorage.getItem("CurrentTeamMembers");
        // else
        // patvalue=localStorage.getItem("PCRCareGivers");
        let  customer=localStorage.getItem("Customerid");
        if(patvalue!=null && patvalue!="")
        {          
           var res =JSON.parse(patvalue);
           while (res.length != 3) {
            res=res.concat(JSON.parse('{"id":null, "name":"", "title":""}'));
           }
           handleindexdbsaveload(res);
           localStorage.setItem("PCRCareGivers","");
        }else{
          setState(initialData)
        }
    } catch (err) {
    }
  }
  const handleindexdbsaveload = async (value: any): Promise<void> => {
    let db: any = null;
    db = localStorage.getItem("PatientDB");
    if (Indexdb != null || Indexdb != "") {
        const indexedDb = new IndexedDb(db);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        let careValue = await indexedDb.getAllValue("Caregivers");
        await indexedDb.putValue("Caregivers",{ column: value, Patid: 0 }, "caregivers")
        setState(value);
    }
}

  useEffect(() => {
    async function fetchData() {
      let db = localStorage.getItem("PatientDB");
      if (db !== null && db !== "") {
        const indexedDb = new IndexedDb(db);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        let careValue = await indexedDb.getAllValue("Caregivers");

        if (
          careValue &&
          careValue.length > 0 &&
          careValue[0]?.value?.column.length > 0
        ) {
          setState(careValue[0]?.value?.column);
        } else {
          await setDb();
        }
      }
    }
    getCareGiversList();
    fetchData();
  }, []);

  return (
    <div>
      <div className={classes.pcrAddTabHeading}>
        <div>Clinicians</div>
      </div>
      <Grid container className={classes.formContainer} spacing={2}>
        {state.map((row: TCaregivers, index: number) => {
          return (
            <React.Fragment key={index}>
              <Grid item xs={12} sm={5} style={{ borderBottom: "1px solid #f1f1f1" }}>
                {index === 0 && (
                  <div className={classes.formControlLabel}>NAME</div>
                )}
                <React.Fragment>
                  <Autocomplete
                  id="name"
                  classes={{
                    paper: classes.autocompleteList,
                    option: classes.autocompleteListOptions,
                  }}
                    value={row.name||null}
                    // inputValue={row.name}

                    onInputChange={(event, newValue, r) => {
                      if (typeof newValue === "string") {
                        handleOnChange(
                          {
                            id: row.id,
                            name: newValue || "",
                            title: row?.title || "",
                          },
                          index
                        );
                      }
                      setInputValue(newValue);
                    }}
                    onChange={(event, newValue,r) => {
                      if (typeof newValue === 'string') {
                        handleOnChange(
                          {
                            id:  row.id,
                            name:  newValue||'',
                            title:  row?.title||''
                          },
                          index
                        )
                      } else if (newValue && newValue.name) {
                        // Create a new value from the user input
                        handleOnChange(
                          {
                            id:  row.id,
                            name:  newValue.name||'',
                            title:  newValue?.title||''
                          },
                          index
                        )
                      }else if(r==="clear"){
                        handleOnChange(
                          {
                            id:  null,
                            name:  "",
                            title:  "",
                          },
                          index
                        );
                      }else if(newValue) {
                        handleOnChange(
                          newValue,
                          index
                        )
                      }
                    }}
                    onBlur={(e) =>  setCareGiversListChanged((a: number) => a+1)}
                    options={usersList}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === 'string') {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.name) {
                        return option.name;
                      }
                      // Regular option
                      return option.title;
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, {
                        inputValue:row.name,
                        getOptionLabel: params.getOptionLabel,
                      });
                      return filtered;
                    }}
                    renderOption={(option, { inputValue }) => {
                      return (
                        <div>
                          <Typography color="textPrimary" component={"span"} style={{fontSize:17,marginRight:10}}>
                            {option.name}
                          </Typography>{" "}
                          {" "}
                          <Typography component={"span"} style={{fontSize:15,color:'#a9a9a9'}}>
                            {option.title}
                          </Typography>
                        </div>
                      );
                    }}
                    closeIcon={<HighlightOffIcon fontSize="small" />}
                    freeSolo
                    className={classes.autocomplete}
                    renderInput={(params) => (
                      <TextField
                        variant="outlined"
                        placeholder="Name"
                        className={classes.textFieldInput}
                        {...params}
                      />
                    )}
                  />
                </React.Fragment>
              </Grid>
              <Grid item xs={12} sm={7} style={{ borderBottom: "1px solid #f1f1f1" }}>
                {index === 0 && (
                  <div className={classes.formControlLabel}>TITLE</div>
                )}
                <React.Fragment>
                  <TextField
                    onChange={(e) => {
                      handleOnChange(
                        { name: row.name, title: e.target.value, id: row?.id||null },
                        index
                      );
                    }}
                    value={row.title || ""}
                    onBlur={(e) =>  setCareGiversListChanged((a: number) => a+1)}
                    name={"title"}
                    InputProps={{
                      classes: { root: classes.textFieldInput },
                    }}
                    inputProps={{ maxLength: 100, minLength: 0,autocomplete:'disabled' }}
                    placeholder="Position"
                    //error={errors.MRN} helperText={errors.MRN? errors.MRN.message: ""}
                    variant="outlined"
                  ></TextField>
                </React.Fragment>
              </Grid>
            </React.Fragment>
          );
        })}
      </Grid>
    </div>
  );
};

export default Caregivers;
